import React, { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { LayoutProvider } from '../../contexts/LayoutContext'
import ModernSidebar from './ModernSidebar'
import ModernHeader from './ModernHeader'
import { HEADER_HEIGHT_PX, ACTION_BAR_HEIGHT_PX } from '../../constants/layout'

const ModernLayout: React.FC = () => {
    const [sidebarOpen, setSidebarOpen] = useState(true)
    const location = useLocation()

    // Rotas onde a ActionBar NÃO aparece (então o padding top deve ser menor)
    const routesWithoutActionBar = ['/', '/dashboard', '/fluxos']
    const hasActionBar = !routesWithoutActionBar.includes(location.pathname)

    // Cálculo dinâmico do padding top
    // Se tiver ActionBar: 64 (header) + 85 (actionbar) + 32 (respiro) = 181px
    // Se não tiver: 64 (header) + 32 (respiro) = 96px
    const paddingTop = hasActionBar 
        ? `${HEADER_HEIGHT_PX + ACTION_BAR_HEIGHT_PX + 32}px` 
        : `${HEADER_HEIGHT_PX + 32}px`

    return (
        <div className="min-h-screen bg-slate-50 dark:bg-slate-900 font-sans text-slate-900 dark:text-slate-100">
            <ModernSidebar open={sidebarOpen} setOpen={setSidebarOpen} />
            <ModernHeader open={sidebarOpen} setOpen={setSidebarOpen} />

            <main
                className="pl-4 pr-4 pb-8 min-h-screen transition-[margin-left,width] duration-300 ease-in-out overflow-x-visible"
                style={{
                    paddingTop, // Padding dinâmico
                    marginLeft: sidebarOpen ? '16rem' : '4rem',
                    width: sidebarOpen ? 'calc(100% - 16rem)' : 'calc(100% - 4rem)',
                }}
            >
                <div className="w-full animate-fade-in min-w-0 flex flex-col min-h-[calc(100vh-8rem)] overflow-x-visible">
                    <LayoutProvider sidebarOpen={sidebarOpen}>
                        <Outlet />
                    </LayoutProvider>
                </div>
            </main>
        </div>
    )
}

export default ModernLayout
